function credentialsReducer() {
  return {};
}

export default credentialsReducer;
